module.exports = __webpack_public_path__ + "static/img/lu.c858787c.svg";